import React from 'react'
import AlertsListsScreen from './AlertsListsScreen';
import './AlertsListContainer.css';
import useLogReport from '../../util/hooks/useLogReport';

const AlertsListContainer = () => {


    useLogReport('ALERTS');

    return (
        <AlertsListsScreen />

    )
}

export default AlertsListContainer